var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9187 13.5225V21.6475C22.9187 24.1475 21.427 24.9808 19.5853 24.9808H12.9187C11.077 24.9808 9.58533 24.1475 9.58533 21.6475V13.5225C9.58533 10.8142 11.077 10.1892 12.9187 10.1892C12.9187 10.7058 13.127 11.1725 13.4686 11.5142C13.8103 11.8558 14.277 12.0642 14.7937 12.0642H17.7103C18.7437 12.0642 19.5853 11.2225 19.5853 10.1892C21.427 10.1892 22.9187 10.8142 22.9187 13.5225Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5852 10.1892C19.5852 11.2225 18.7436 12.0642 17.7102 12.0642H14.7936C14.2769 12.0642 13.8102 11.8558 13.4686 11.5142C13.1269 11.1725 12.9186 10.7058 12.9186 10.1892C12.9186 9.15585 13.7602 8.31418 14.7936 8.31418H17.7102C18.2269 8.31418 18.6936 8.52251 19.0353 8.86418C19.3769 9.20585 19.5852 9.67251 19.5852 10.1892Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9186 17.4809H16.2519",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9186 20.8142H19.5852",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.baddd45ac95466af5e61a5473dcd97ed.svg";
export { ForwardRef as ReactComponent };